module.exports = __webpack_public_path__ + "static/media/image2.a5e0041d.png";